import { Component } from '@angular/core';

/**
 * This is the default layout component used for pages which only need a single router outlet.
 */
@Component({
	selector: 'cc-default-layout',
	templateUrl: './default-layout.component.html',
	styleUrls: ['./default-layout.component.css']
})
export class DefaultLayoutComponent { }